// ══════════════════════════════════════════════════════════════════════════
//  Espera: la marca que barre al CENTRO del espacio que espera.
//
//  Canon 2026-09-22 ("el módulo que lee", lienzo "Esperar en calma"): cuando
//  la forma de lo que viene se conoce va la silueta (`ListaCarpeta cargando`,
//  un esqueleto del tamaño exacto); cuando no (una vista que se arma, el chunk
//  que baja, la carga global) va la marca al centro. Sustituye a la marca con
//  60 px de aire arriba del área: llena lo que le den y centra; en un
//  contenedor sin alto propio toma el del área de trabajo.
//    <Espera label="Leyendo los ensayes…" />
//  `data-gb-cargando` lo pone LogoLoader: el cambio de módulo espera a la vista real.
// ══════════════════════════════════════════════════════════════════════════
import { LogoLoader, MARCA } from './LogoLoader.js';

export const Espera = ({ label, size = MARCA.area, minAlto = 'clamp(240px, 60vh, 640px)', style: sx = {} }) => (
  <div style={{ flex: '1 1 auto', minHeight: minAlto, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
    <LogoLoader size={size} label={label} />
  </div>
);
